import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteInCard } from '../redux/actions/productAction'
import SignIn from '../components/SignIn/SignIn'



const Cart = () => {
    // const produitsDeCart = useSelector(state => state.PrduitsDeCart.produitsCard)
  const produitsDeCart = useSelector(state => state.PrduitsDeCart.produitsCard)
  //  console.log(produitsDeCart.length)


   const dispatch = useDispatch()

   const conver = (price) => (new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(price))

    const onDelete = (id) => {
      dispatch(deleteInCard(id))
    }
    const [showSingIn, setShowSignIn] = useState(false)

    const acheter = () => {
      console.log(produitsDeCart)
      setShowSignIn(prevState => !prevState)
      console.log(showSingIn)
    }

    if(produitsDeCart.length === 0){
      return(
        <p className='CartVide'>
          Votre panier est vide {' '}
          <i className='fas fa-exclamation' style={{fontSize:'48px',color:'red'}}></i>
          <br />
          <p style={{marginTop: "1rem"}}>
            Selectioner les produits dans 
            <br />
            <span style={{color: "blue"}}>
              A-Propos {' '}
              <i className="fas fa-shopping-bag"></i>
            </span>
          </p>  
        </p>
      )
    } else {
      return (    
        <>
          <div className="prodansCardTous">
            <div className='total'>
              Le Total: {conver(produitsDeCart.reduce((amount, item) => item.price + amount, 0))}
            </div>
              {produitsDeCart.map((produit) =>{
              const {id, category, description, image, price, rating, title} = produit;
              return (
                <div className="prodansCard">
                  <img src={image} alt="Image" className='card_Image' />
                  <div className="prodansCardBody">
                    <div className='lesDonneesNombre'>
                      <div className='lesDonnees'>
                        <h4>{title}</h4>
                        <h5>{category}</h5>
                        <div className='price'>{conver(price)}</div>
                      </div>
                    </div>
                    <button type='button' onClick={() => onDelete(id)}>
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>  
                  </div> 
                </div>)
            })}  
            <button className='Acheter' onClick={acheter}>
              Acheter 
            </button>              
          </div>
          {showSingIn ? <SignIn /> : null}
        </>
      )
    }

    

}

export default Cart